exports.IDS = {
  // IMG_URL: "http://192.168.16.23:4243",
  IMG_URL: "https://moneykingnode.profcymadev.com:7777",
  // IMG_URL: "https://node.moneykings.in:7777",


  PAGE: 1,
  PERPAGE: 10,
  TOTALPAGES: 1,
  TOTAL: 1,
  ACTIVE: "Active",
  INACTIVE: "Inactive",
  BLOCK: "BLOCKED",
  UNBLOCK: "UNBLOCKED",
  SLICESTATUS: {
    Idle: "idle",
    Loading: "loading",
    Succeeded: "succeeded",
    Failed: "failed",
  },
};
